export interface FormField<T = string> {
  placeholder?: string;
  value: T;
  oldValue: string | null;
  formatted: string | null;
  dirty: boolean;
  error: string | null;
  errorMode: ErrorMode | null;
}

export enum ErrorMode {
  BelowField = 'belowField',
  PlaceHolder = 'placeholder'
}

export enum FormType {
  CreateAccount = 'CreateAccount',
  SignIn = 'SignIn',
  GroupOrderSignIn = 'GroupOrderSignIn',
  PasswordResetRequest = 'PasswordResetRequest',
}
